export default __webpack_public_path__ + "static/css-02d225c7df0b28341d8d5dff5fbda2a6.png";